import React, { useState, useEffect } from "react";
import { Paper, Stack, Typography, Box, Chip } from "@mui/material";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";

const ConnectionMonitorWidget = ({ lastHeartbeat, isConnected = true }) => {
  const [timeAgo, setTimeAgo] = useState("");

  // Formatear la hora exacta de la última pulsación/heartbeat
  const formatHeartbeatTime = (date) => {
    if (!date) return "--:--:--";
    return new Date(date).toLocaleTimeString("es-MX", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  // Cálculo del tiempo transcurrido "Hace X seg/min"
  useEffect(() => {
    if (!lastHeartbeat) return;

    const updateRelativeTime = () => {
      const seconds = Math.floor((new Date() - new Date(lastHeartbeat)) / 1000);
      if (seconds < 5) setTimeAgo("Ahora mismo");
      else if (seconds < 60) setTimeAgo(`Hace ${seconds}s`);
      else setTimeAgo(`Hace ${Math.floor(seconds / 60)}m`);
    };

    updateRelativeTime();
    const timer = setInterval(updateRelativeTime, 1000);
    return () => clearInterval(timer);
  }, [lastHeartbeat]);

  return (
    <Paper
      elevation={0}
      sx={{
        position: "absolute",
        top: 90,
        right: 20,
        p: 2.5,
        width: 250,
        borderRadius: "20px",
        bgcolor: "#FFFFFF",
        border: "1px solid #EAE8F5",
        boxShadow: "0px 10px 30px rgba(110, 107, 180, 0.08)",
      }}
    >
      {/* Encabezado: Estado de Conexión */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          {isConnected ? (
            <WifiIcon sx={{ color: "#4CAF50", fontSize: 22 }} />
          ) : (
            <WifiOffIcon sx={{ color: "#EF5350", fontSize: 22 }} />
          )}
          <Typography
            variant="body2"
            fontWeight={600}
            sx={{ color: "#6A6B87", letterSpacing: "-0.2px" }}
          >
            Conexión
          </Typography>
        </Stack>

        <Chip
          label={isConnected ? "En línea" : "Desconectado"}
          size="small"
          sx={{
            bgcolor: isConnected ? "#E8F5E9" : "#FFEBEE",
            color: isConnected ? "#2E7D32" : "#C62828",
            fontWeight: 700,
            fontSize: "0.72rem",
            borderRadius: "10px",
          }}
        />
      </Stack>

      {/* Tarjeta Principal Lila Pastel */}
      <Box
        sx={{
          textAlign: "center",
          py: 2,
          px: 1.5,
          bgcolor: "#F2EEFF",
          borderRadius: "16px",
          border: "1px solid #E3DCFF",
        }}
      >
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0.6}
          mb={0.5}
        >
          <AccessTimeRoundedIcon sx={{ fontSize: 14, color: "#7B61FF" }} />
          <Typography
            variant="caption"
            sx={{
              color: "#7B61FF",
              fontWeight: 700,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              fontSize: "0.65rem",
            }}
          >
            Última actualización
          </Typography>
        </Stack>

        {/* Hora del último heartbeat */}
        <Typography
          variant="h4"
          sx={{
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
            fontWeight: 700,
            color: "#4A3B99",
            letterSpacing: 1,
            my: 0.5,
          }}
        >
          {formatHeartbeatTime(lastHeartbeat)}
        </Typography>

        {/* Indicador suave de tiempo relativo */}
        {lastHeartbeat && (
          <Typography
            variant="caption"
            sx={{ color: "#8E82C0", fontWeight: 500 }}
          >
            {timeAgo}
          </Typography>
        )}
      </Box>

      {/* Pie del Widget */}
      <Box mt={1.8} textAlign="center">
        <Typography
          variant="caption"
          sx={{ color: "#A0A0B8", fontSize: "0.7rem" }}
        >
          Sincronizado con el servidor
        </Typography>
      </Box>
    </Paper>
  );
};

export default ConnectionMonitorWidget;
